import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  HOME_CREATE_PRODUCT_SUBSCRIPTION_BEGIN,
  HOME_CREATE_PRODUCT_SUBSCRIPTION_SUCCESS,
  HOME_CREATE_PRODUCT_SUBSCRIPTION_FAILURE,
  HOME_CREATE_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
export function createProductSubscription(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: HOME_CREATE_PRODUCT_SUBSCRIPTION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/create-product-subscription`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CREATE_PRODUCT_SUBSCRIPTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_CREATE_PRODUCT_SUBSCRIPTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateProductSubscriptionError() {
  return {
    type: HOME_CREATE_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
  };
}

export function useCreateProductSubscription() {
  const dispatch = useDispatch();

  const { createProductSubscriptionPending, createProductSubscriptionError } =
    useSelector(
      (state) => ({
        createProductSubscriptionPending:
          state.home.createProductSubscriptionPending,
        createProductSubscriptionError:
          state.home.createProductSubscriptionError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(createProductSubscription(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCreateProductSubscriptionError());
  }, [dispatch]);

  return {
    createProductSubscription: boundAction,
    createProductSubscriptionPending,
    createProductSubscriptionError,
    dismissCreateProductSubscriptionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CREATE_PRODUCT_SUBSCRIPTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createProductSubscriptionPending: true,
        createProductSubscriptionError: null,
      };

    case HOME_CREATE_PRODUCT_SUBSCRIPTION_SUCCESS:
      // The request is success
      return {
        ...state,
        createProductSubscriptionPending: false,
        createProductSubscriptionError: null,
      };

    case HOME_CREATE_PRODUCT_SUBSCRIPTION_FAILURE:
      // The request is failed
      return {
        ...state,
        createProductSubscriptionPending: false,
        createProductSubscriptionError: action.data.error,
      };

    case HOME_CREATE_PRODUCT_SUBSCRIPTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createProductSubscriptionError: null,
      };

    default:
      return state;
  }
}
